import { render } from "./CancelAgent.vue?vue&type=template&id=7f806e72"
import script from "./CancelAgent.vue?vue&type=script&lang=js"
export * from "./CancelAgent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__